<template>
  <div class="detailsPop" v-if="popInfo.show">
    <el-dialog
      title="验证"
      :visible.sync="popInfo.show"
      custom-class="detail-box"
      :fullscreen="false"
      :lock-scroll="true"
      :center="true"
      :modal="false"
      :close-on-click-modal="false"
    >
      <span class="txt1">访问过于频繁，请输入验证码</span>
      <div class="input-box">
        <div class="fl">
          <el-input v-model="code" placeholder="请输入图形验证码"></el-input>
        </div>
        <div class="fr">
          <img :src="url" alt="" @click="getCode()" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="popInfo.show = false">取消</el-button>
        <el-button type="primary" @click="verifyCode()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Verifica } from "@/config/axios/api";
import staticFunc from "@/config/static/func";
export default {
  name: "verification",
  props: ["popInfo"],
  data() {
    return {
      url: "",
      code_key: "",
      code: "",
    };
  },
  created() {
    this.getCode();
  },
  methods: {
    getCode() {
      loginSdk.requestAction("image_code").then((res) => {
        if (res.code == 0) {
          this.url = res.data.base64;
          this.code_key = res.data.key;
        }
      });
    },
    verifyCode() {
      this.$emit("sendSmsCode", this.code_key, this.code);
    },
  },
};
</script>

<style scoped lang="scss">
.detailsPop {
  .el-dialog__wrapper {
    background: rgba(0, 0, 0, 0.5);
  }
  & ::v-deep .detail-box {
    width: 408px;
    height: 211px;
    background: #ffffff;
    border-radius: 22px;
    position: absolute;
    left: 50%;
    top: 0;
    margin-left: -204px;
    margin-top: -105.5px;
    .el-dialog__header {
      padding: 0;
      text-align: left;
      margin-top: 26px;
      padding-left: 22px;
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 24px;
      .el-dialog__close {
        font-weight: bold;
      }
    }
    .el-dialog__body {
      padding: 0;
      box-sizing: border-box;
      overflow: hidden;
      background: none;
      padding-left: 22px;
      padding-right: 22px;
      .txt1 {
        display: block;
        margin-top: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 17px;
      }
      .input-box {
        width: 100%;
        margin-top: 8px;
        .fl {
          float: left;
          width: 256px;
        }
        .fr {
          float: left;
          width: 102px;
          height: 40px;
          background: #efefef;
          border-radius: 6px;
          margin-left: 6px;
          overflow: hidden;
          img {
            display: block;
            width: 100%;
            height: 100%;
            cursor: pointer;
          }
        }
      }
    }
    .el-dialog__footer {
      padding: 0 22px;
      margin-top: 24px;
      .dialog-footer {
        width: 268px;
        .el-button {
          width: 128px;
          height: 40px;
          background: #edf2f5;
          border-radius: 12px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
        }
        .el-button.el-button--primary {
          background: #4d2ef7;
          color: #ffffff;
        }
      }
    }
  }
}
</style>